{
  "common": {
    "cancel": "Abbrechen",
    "save": "Speichern",
    "delete": "Löschen",
    "done": "Fertig",
    "edit": "Bearbeiten",
    "search": "Suchen",
    "loading": "Lädt…",
    "yes": "Ja",
    "no": "Nein",
    "settings": "Einstellungen",
    "back": "Zurück",
    "close": "Schließen",
    "open": "Öffnen",
    "copy": "Kopieren",
    "restore": "Wiederherstellen",
    "untitled": "Ohne Titel",
    "create": "Erstellen",
    "revoke": "Widerrufen",
    "never": "Nie",
    "tryAgain": "Erneut versuchen",
    "reload": "Neu laden",
    "update": "Aktualisieren",
    "insert": "Einfügen",
    "loadingShort": "Lädt",
    "unknown": "Unbekannt",
    "sampleSentence": "Der schnelle braune Fuchs"
  },
  "sidebar": {
    "views": "Ansichten",
    "tags": "Tags",
    "edit": "Bearbeiten",
    "done": "Fertig",
    "account": "Konto",
    "newNote": "Neue Notiz",
    "editTag": "Tag bearbeiten",
    "tagOptions": "Tag-Optionen",
    "reorder": "{{label}} verschieben",
    "showView": "{{label}} anzeigen",
    "hideView": "{{label}} ausblenden",
    "editViews": "Ansichten bearbeiten",
    "doneEditingViews": "Bearbeitung beenden",
    "samplePeep": "Caliu ist…",
    "sampleQuiet": "Ein ruhiger Ort, an dem deine Gedanken leben und atmen können."
  },
  "views": {
    "all": "Alle Notizen",
    "today": "Heute",
    "todo": "Aufgaben",
    "pinned": "Angeheftet",
    "untagged": "Ohne Tags",
    "thisWeek": "Diese Woche",
    "shared": "Von mir geteilt",
    "sharedWithMe": "Mit mir geteilt",
    "attachments": "Anhänge",
    "trash": "Papierkorb",
    "archive": "Archiviert"
  },
  "noteList": {
    "empty": "Noch keine Notizen",
    "emptySubtitle": "Erstelle deine erste Notiz, um zu beginnen.",
    "untitled": "Ohne Titel",
    "selectNote": "Notiz auswählen",
    "selectNoteHint": "Wähle eine Notiz aus der Liste oder erstelle eine neue.",
    "selectRestoreOrDelete": "Wähle eine Notiz, um sie wiederherzustellen oder endgültig zu löschen",
    "selectSharedToView": "Wähle eine geteilte Notiz, um sie anzuzeigen",
    "searchPlaceholder": "Notizen suchen…",
    "selectNotes": "Notizen auswählen",
    "openSidebar": "Seitenleiste öffnen",
    "cancelSelection": "Auswahl abbrechen",
    "clearSelection": "Auswahl aufheben",
    "emptyTrash": "Papierkorb leeren",
    "newNote": "Neue Notiz",
    "noteCount_one": "{{count}} Notiz",
    "noteCount_other": "{{count}} Notizen",
    "sortBy": "Sortieren nach",
    "preview": "Vorschau",
    "modificationDate": "Änderungsdatum",
    "creationDate": "Erstellungsdatum",
    "title": "Titel",
    "manual": "Manuell",
    "newestOnTop": "Neueste oben",
    "small": "Klein",
    "medium": "Mittel",
    "large": "Groß",
    "empty_pinned": "Noch nichts angeheftet",
    "empty_pinned_subtitle": "Hefte eine Notiz an, um sie hier schnell zu finden.",
    "empty_today": "Heute noch nichts bearbeitet",
    "empty_today_subtitle": "Heute bearbeitete Notizen erscheinen hier.",
    "empty_todo": "Noch keine Aufgaben",
    "empty_todo_subtitle": "Notizen mit offenen Aufgaben erscheinen hier.",
    "empty_untagged": "Alles ist getaggt",
    "empty_untagged_subtitle": "Notizen ohne Tags erscheinen hier.",
    "empty_thisWeek": "Nichts diese Woche",
    "empty_thisWeek_subtitle": "Notizen aus den letzten 7 Tagen erscheinen hier.",
    "empty_shared": "Keine geteilten Notizen",
    "empty_shared_subtitle": "Notizen, die du teilst, erscheinen hier.",
    "empty_attachments": "Noch keine Anhänge",
    "empty_attachments_subtitle": "Notizen mit Bildern oder Dateien erscheinen hier.",
    "justNow": "Gerade eben",
    "minutesAgo": "vor {{count}} Min.",
    "today": "Heute",
    "yesterday": "Gestern",
    "deletedOn": "Gelöscht am {{date}}",
    "newNoteShortcut": "Neue Notiz ({{shortcut}})",
    "noContent": "Kein Inhalt",
    "selectUnarchiveOrDelete": "Wähle eine Notiz, um sie aus dem Archiv zu holen oder zu löschen",
    "view": "Ansicht",
    "density": "Dichte",
    "exportAll": "Alle exportieren"
  },
  "editor": {
    "attachmentTooLarge": "Diese Datei ist zu groß zum Anhängen. Das Limit liegt bei 100 MB.",
    "placeholder": "Schreibe los…",
    "noMatchingCommands": "Keine passenden Befehle",
    "newNote": "neue Notiz",
    "noResults": "Keine Ergebnisse",
    "foldSection": "Abschnitt einklappen",
    "unfoldSection": "Abschnitt ausklappen",
    "dragSection": "Abschnitt verschieben",
    "presenceLabel": "Auch hier: {{names}}"
  },
  "noteActions": {
    "pin": "Anheften",
    "unpin": "Lösen",
    "pinToTop": "Oben anheften",
    "makeReadOnly": "Schreibgeschützt machen",
    "makeEditable": "Bearbeitbar machen",
    "readOnlyNote": "Schreibgeschützte Notiz",
    "shareNote": "Notiz teilen",
    "share": "Teilen",
    "publiclyShared": "Öffentlich geteilt",
    "privateNote": "Private Notiz",
    "linkCreated": "Link erstellt",
    "linkCreatedAndCopied": "Link erstellt und kopiert",
    "linkRevoked": "Freigabe-Link widerrufen",
    "failedToCreateShareLink": "Freigabe-Link konnte nicht erstellt werden",
    "failedToRevokeShareLink": "Freigabe-Link konnte nicht widerrufen werden",
    "thisNoteIsPrivate": "Diese Notiz ist privat.",
    "createPublicLink": "Öffentlichen Link erstellen",
    "creatingLink": "Erstelle Link…",
    "revokeLink": "Link widerrufen",
    "revokingLink": "Widerrufe…",
    "copyLink": "Link kopieren",
    "copyNoteId": "Notiz-ID kopieren",
    "noteIdCopied": "Notiz-ID kopiert",
    "exportAs": "Exportieren als",
    "exportMarkdown": "Markdown",
    "exportPlainText": "Reintext",
    "exportHtml": "HTML",
    "exportRtf": "RTF",
    "exportEpub": "ePub",
    "exportTextpack": "TextPack",
    "exportFailed": "Export fehlgeschlagen",
    "viewHistory": "Verlauf anzeigen",
    "duplicate": "Duplizieren",
    "duplicateFailed": "Notiz konnte nicht dupliziert werden",
    "select": "Auswählen",
    "delete": "Löschen",
    "moveToTrash": "In den Papierkorb",
    "archive": "Archivieren",
    "unarchive": "Aus Archiv holen",
    "tags": "Tags",
    "addTag": "Tag hinzufügen",
    "noTagsYet": "Noch keine Tags",
    "addTagFailed": "Tag konnte nicht hinzugefügt werden",
    "removeTagFailed": "Tag konnte nicht entfernt werden"
  },
  "userMenu": {
    "theme": "Theme",
    "typography": "Typografie",
    "language": "Sprache",
    "apiKeys": "API-Schlüssel",
    "devices": "Geräte",
    "connectedApps": "Verbundene Apps",
    "help": "Hilfe",
    "logOut": "Abmelden",
    "defaultUserName": "Caliu-Nutzer",
    "editName": "Name bearbeiten",
    "nameLabel": "Name",
    "namePlaceholder": "Ihr Name",
    "upgradeToPro": "Auf Caliu Pro upgraden",
    "replayOnboarding": "Einführung erneut anzeigen",
    "logOutTitle": "Abmelden?",
    "logOutBody": "Deine Notizen bleiben auf diesem Gerät und du kannst sie weiter lesen und schreiben. Melde dich wieder an, um zu synchronisieren.",
    "logOutPending_one": "{{count}} Änderung ist noch nicht synchronisiert. Sie bleibt auf diesem Gerät, bis du dich wieder anmeldest.",
    "logOutPending_other": "{{count}} Änderungen sind noch nicht synchronisiert. Sie bleiben auf diesem Gerät, bis du dich wieder anmeldest.",
    "logOutKeep": "Abmelden",
    "logOutAndRemove": "Abmelden und Notizen entfernen"
  },
  "help": {
    "title": "Hilfe-Center",
    "searchPlaceholder": "Hilfeartikel durchsuchen",
    "noResults": "Keine Artikel entsprechen deiner Suche.",
    "offline": "Die Hilfe ist offline nicht verfügbar. Sie wird geladen, sobald du wieder online bist."
  },
  "fonts": {
    "uiFont": "Oberflächenschrift",
    "body": "Fließtext",
    "headings": "Überschriften",
    "code": "Code",
    "sans": "Sans",
    "serif": "Serif",
    "mono": "Mono",
    "editor": "Editor",
    "ui": "Oberfläche",
    "reset": "Zurücksetzen"
  },
  "themes": {
    "light": "Hell",
    "dark": "Dunkel",
    "system": "System"
  },
  "languages": {
    "systemHint": "Vom Gerät erkannt",
    "names": {
      "en": "Englisch",
      "es": "Spanisch",
      "ca": "Katalanisch",
      "fr": "Französisch",
      "de": "Deutsch",
      "it": "Italienisch",
      "pt": "Portugiesisch",
      "nl": "Niederländisch",
      "ja": "Japanisch",
      "zh-CN": "Chinesisch (vereinfacht)",
      "ko": "Koreanisch",
      "zh-TW": "Chinesisch (traditionell)",
      "ru": "Russisch"
    }
  },
  "bulkActions": {
    "pinSelected": "Ausgewählte anheften",
    "unpinSelected": "Ausgewählte lösen",
    "pin": "Anheften",
    "addTag": "Tag hinzufügen",
    "filterTags": "Tags filtern…",
    "noTagsFound": "Keine Tags gefunden",
    "exportSelected": "Ausgewählte exportieren",
    "restoreSelected": "Ausgewählte wiederherstellen",
    "deletePermanently": "Endgültig löschen",
    "moveToTrash": "In den Papierkorb",
    "archiveSelected": "Auswahl archivieren",
    "unarchiveSelected": "Auswahl aus Archiv holen",
    "exportingTitle": "Deine Notizen werden exportiert",
    "exportingBody": "Das kann einen Moment dauern. Lass diesen Tab geöffnet, bis der Vorgang abgeschlossen ist.",
    "exportingProgress": "{{done}} von {{total}}"
  },
  "commandPalette": {
    "placeholder": "Notizen, Tags, Befehle suchen…",
    "noResults": "Keine Ergebnisse für „{{query}}“",
    "currentNote": "Aktuelle Notiz",
    "navigation": "Navigation",
    "notes": "Notizen",
    "tags": "Tags",
    "newNote": "Neue Notiz",
    "allNotes": "Alle Notizen",
    "todaysNotes": "Heutige Notizen",
    "todo": "Aufgaben",
    "pinnedNotes": "Angeheftete Notizen",
    "trash": "Papierkorb",
    "importNotes": "Notizen importieren",
    "changeTheme": "Theme ändern",
    "keyboardShortcuts": "Tastenkürzel",
    "pinNote": "Notiz anheften",
    "unpinNote": "Notiz lösen",
    "restoreNote": "Notiz wiederherstellen",
    "copyShareLink": "Freigabe-Link kopieren",
    "makePrivate": "Privat machen",
    "toggleFullscreen": "Vollbild umschalten",
    "noteInfo": "Notiz-Info",
    "moveToTrash": "In den Papierkorb",
    "archiveNote": "Notiz archivieren",
    "unarchiveNote": "Notiz aus Archiv holen",
    "archive": "Archiviert"
  },
  "noteHistory": {
    "title": "Notiz-Verlauf",
    "requiresConnection": "Der Verlauf erfordert eine Verbindung.",
    "reconnect": "Verbinde dich mit dem Internet und versuche es erneut.",
    "noHistory": "Noch kein Verlauf für diese Notiz.",
    "windowMerged": "Bearbeitungen innerhalb von 5 Minuten werden zu einem Eintrag zusammengeführt.",
    "selectVersion": "Wähle eine Version für die Vorschau",
    "encrypted": "Verschlüsselte Version",
    "encryptedHint": "Diese Version wurde mit Ende-zu-Ende-Verschlüsselung gespeichert. Öffne die Notiz, um den aktuellen Inhalt zu sehen.",
    "restoreVersion": "Diese Version wiederherstellen?",
    "restoreVersionHint": "Damit wird der aktuelle Inhalt der Notiz durch die Version vom {{date}} ersetzt.",
    "current": "Aktuell",
    "created": "Erstellt",
    "trashed": "Gelöscht",
    "restored": "Wiederhergestellt",
    "edited": "Bearbeitet"
  },
  "apiKeys": {
    "title": "API-Schlüssel",
    "empty": "Noch keine API-Schlüssel.",
    "emptyHint": "Erstelle einen, um die API zu nutzen.",
    "created": "Erstellt am {{date}}",
    "lastUsed": "Zuletzt verwendet: {{date}}",
    "revokeKey": "Schlüssel widerrufen",
    "viewApiDocs": "API-Dokumentation",
    "newApiKey": "Neuer API-Schlüssel",
    "apiKeyCreated": "API-Schlüssel erstellt",
    "createApiKey": "API-Schlüssel erstellen",
    "copyHint": "Kopiere diesen Schlüssel jetzt. Du kannst ihn später nicht mehr sehen.",
    "copyToClipboard": "In die Zwischenablage kopieren",
    "keyName": "Schlüsselname",
    "keyNamePlaceholder": "z. B. Mein Skript, Zapier-Integration",
    "createKey": "Schlüssel erstellen",
    "revokeKeyTitle": "API-Schlüssel widerrufen",
    "revokeKeyHint": "Damit wird dieser API-Schlüssel dauerhaft widerrufen. Alle Anwendungen, die ihn verwenden, verlieren sofort den Zugriff.",
    "keyPrefix": "caliu_{{prefix}}…"
  },
  "connectedApps": {
    "title": "Verbundene Apps",
    "empty": "Noch keine verbundenen Apps.",
    "emptyHint": "Verbinde Claude, ChatGPT oder einen anderen KI-Assistenten, um deine Notizen im Chat zu nutzen. Wie das geht, zeigt der Abschnitt Caliu mit KI in der Hilfe.",
    "connected": "Verbunden am {{date}}",
    "lastUsed": "Zuletzt verwendet: {{date}}",
    "revoke": "Widerrufen",
    "revokeTitle": "Verbindung widerrufen",
    "revokeHint": "Damit wird der Zugriff von <strong>{{name}}</strong> auf dein Caliu-Konto widerrufen und die verwendeten Anmeldedaten gelöscht. Der Zugriff wird sofort entzogen.",
    "thisApp": "diese App",
    "defaultScope": "mcp"
  },
  "noteStats": {
    "writing": "Schreiben",
    "metadata": "Metadaten",
    "words": "Wörter",
    "characters": "Zeichen",
    "paragraphs": "Absätze",
    "readTime": "Lesezeit",
    "minutes": "{{count}} Min.",
    "tags": "Tags",
    "outgoingLinks": "Ausgehende Links",
    "backlinks": "Rückverweise",
    "created": "Erstellt",
    "modified": "Geändert",
    "noteStatistics": "Notiz-Statistiken",
    "identifier": "Kennung"
  },
  "inspector": {
    "tabInfo": "Info",
    "tabOutline": "Gliederung",
    "tabHistory": "Verlauf",
    "dates": "Daten",
    "noHeadings": "Keine Überschriften in dieser Notiz",
    "noBacklinks": "Keine Notizen verlinken hierher",
    "noOutgoing": "Diese Notiz verlinkt auf nichts",
    "noAttachments": "Keine Anhänge in dieser Notiz",
    "historyOffline": "Der Versionsverlauf benötigt eine Verbindung",
    "historyLoadMore": "Mehr laden"
  },
  "devices": {
    "title": "Geräte",
    "offline": "Du bist offline.",
    "offlineHint": "Verbinde dich mit dem Internet, um deine Geräte zu sehen.",
    "noSessions": "Keine aktiven Sitzungen gefunden.",
    "thisDevice": "Dieses Gerät",
    "lastUsed": "Zuletzt verwendet: {{date}}",
    "created": "Erstellt: {{date}}",
    "signOutCurrent": "Auf diesem Gerät abmelden",
    "signOut": "Abmelden",
    "confirmCurrentTitle": "Auf diesem Gerät abmelden?",
    "confirmRevokeTitle": "Gerät widerrufen?",
    "confirmCurrentBody": "Du wirst auf diesem Browser von Caliu abgemeldet, und die Notizen werden von diesem Gerät entfernt. Melde dich jederzeit wieder an, dann kommen sie aus deinem Konto zurück.",
    "confirmRevokeBody": "Das Gerät wird sofort abgemeldet. Nicht synchronisierte Änderungen bleiben dort, bis du dich erneut anmeldest.",
    "revoke": "Widerrufen"
  },
  "errorScreen": {
    "title": "Etwas ist schiefgelaufen",
    "defaultMessage": "Ein unerwarteter Fehler ist aufgetreten. Versuche, die Seite neu zu laden."
  },
  "importModal": {
    "title": "Notizen importieren",
    "dropToImport": "Zum Importieren ablegen",
    "dropOrClick": "Dateien ablegen oder zum Durchsuchen klicken",
    "removeFile": "Datei entfernen",
    "keepNote": "Für Google Keep exportiere ein Takeout-ZIP und lade dieses Archiv direkt hoch.",
    "importedCount_one": "<strong>{{count}}</strong> Notiz importiert",
    "importedCount_other": "<strong>{{count}}</strong> Notizen importiert",
    "fromSource": " aus {{source}}",
    "importing": "Wird importiert…",
    "importN": "{{count}} Dateien importieren",
    "importBtn": "Importieren"
  },
  "share": {
    "shareNote": "Notiz teilen",
    "publiclySharedAria": "Notiz ist öffentlich geteilt",
    "copyLink": "Link kopieren",
    "revokingLink": "Wird widerrufen…",
    "revokeLink": "Link widerrufen",
    "creatingLink": "Link wird erstellt…",
    "createPublicLink": "Öffentlichen Link erstellen",
    "shareThisNotePublicly": "Diese Notiz öffentlich teilen",
    "thisNoteIsPrivate": "Diese Notiz ist privat.",
    "publiclyShared": "Öffentlich geteilt",
    "privateNote": "Private Notiz"
  },
  "shortcuts": {
    "searchPlaceholder": "Tastaturkürzel suchen…",
    "pressNew": "Neues Tastaturkürzel drücken…",
    "resetToDefault": "Auf Standard zurücksetzen",
    "noMatches": "Keine Tastaturkürzel passen zu „<strong>{{query}}</strong>“",
    "navigate": "navigieren",
    "edit": "bearbeiten",
    "closeAction": "schließen",
    "resetAll": "Alles zurücksetzen"
  },
  "tagEditor": {
    "icon": "Symbol",
    "color": "Farbe",
    "searchIcons": "Symbole suchen",
    "noIcons": "Keine passenden Symbole",
    "categories": {
      "essentials": "Grundlagen",
      "work": "Arbeit und Technik",
      "ideas": "Ideen und Kreatives",
      "life": "Menschen und Zuhause",
      "travel": "Reisen und Natur",
      "fun": "Essen, Gesundheit und Freizeit"
    }
  },
  "tagActions": {
    "pin": "Tag anheften",
    "unpin": "Tag lösen",
    "rename": "Umbenennen…",
    "renameTitle": "Tag umbenennen",
    "renameConfirm": "Umbenennen",
    "renameHint": "Der Tag wird in allen Notizen aktualisiert, die ihn verwenden, einschließlich archivierter Notizen und Papierkorb.",
    "renamed": "Tag umbenannt",
    "nameInUse": "Dieser Name wird bereits verwendet",
    "invalidName": "Tag-Namen dürfen nur Buchstaben, Zahlen, Leerzeichen, Bindestriche und Unterstriche enthalten",
    "pinFailed": "Tag konnte nicht aktualisiert werden",
    "renameFailed": "Tag konnte nicht umbenannt werden",
    "editAppearance": "Aussehen bearbeiten"
  },
  "auth": {
    "appName": "Caliu",
    "or": "oder",
    "email": "E-Mail",
    "emailPlaceholder": "du@beispiel.de",
    "password": "Passwort",
    "passwordPlaceholder": "Passwort",
    "name": "Name",
    "namePlaceholder": "Dein Name",
    "confirmPassword": "Passwort bestätigen",
    "newPassword": "Neues Passwort",
    "confirmNewPassword": "Neues Passwort bestätigen",
    "signInSubtitle": "Bei deinem Konto anmelden",
    "createAccountSubtitle": "Erstelle dein Konto",
    "forgotPassword": "Passwort vergessen?",
    "signingIn": "Anmelden…",
    "signIn": "Anmelden",
    "noAccount": "Du hast noch kein Konto?",
    "signUp": "Registrieren",
    "haveAccount": "Du hast bereits ein Konto?",
    "creatingAccount": "Konto wird erstellt…",
    "createAccount": "Konto erstellen",
    "googleSignUpAria": "Mit Google registrieren",
    "signupClosedTitle": "Registrierungen sind aktuell geschlossen",
    "signupClosedBody": "Caliu befindet sich in der privaten Beta. Trag dich auf caliuapp.com in die Warteliste ein, um frühen Zugang zu erhalten.",
    "joinWaitlist": "Auf die Warteliste setzen",
    "forgotTitle": "Passwort zurücksetzen",
    "forgotSubtitle": "Gib deine E-Mail an, und wir senden dir einen Link zum Zurücksetzen.",
    "sendResetLink": "Reset-Link senden",
    "sending": "Senden…",
    "checkYourEmail": "Schau in deine E-Mail",
    "resetLinkSentPrefix": "Falls ",
    "resetLinkSentSuffix": " ein Konto hat, haben wir einen Reset-Link gesendet. Er läuft in 1 Stunde ab.",
    "backToSignIn": "Zurück zur Anmeldung",
    "verifySentPrefix": "Wir haben einen Bestätigungslink an ",
    "verifySentSuffix": " gesendet. Klick darauf, um dein Konto zu aktivieren.",
    "linkExpires10m": "Der Link läuft in 10 Minuten ab.",
    "resending": "Erneut senden…",
    "resendEmail": "E-Mail erneut senden",
    "wrongEmail": "Falsche E-Mail?",
    "goBack": "Zurück",
    "invalidResetLinkTitle": "Ungültiger Reset-Link",
    "invalidResetLinkBody": "Dieser Link ist ungültig oder abgelaufen.",
    "requestNewLink": "Neuen Link anfordern",
    "setNewPasswordTitle": "Neues Passwort festlegen",
    "setNewPasswordHint": "Wähle ein starkes Passwort.",
    "updatingPassword": "Wird aktualisiert…",
    "updatePassword": "Passwort aktualisieren",
    "localNotesTitle": "Du hast Notizen auf diesem Gerät",
    "localNotesBody_one": "Du hast hier {{count}} Notiz geschrieben, bevor du dich angemeldet hast. Was soll damit geschehen?",
    "localNotesBody_other": "Du hast hier {{count}} Notizen geschrieben, bevor du dich angemeldet hast. Was soll damit geschehen?",
    "localNotesDelete": "Löschen",
    "localNotesMerge": "Zu meinem Konto hinzufügen",
    "backToMyNotes": "Zurück zu meinen Notizen",
    "errorGoogleAuthFailed": "Google-Anmeldung fehlgeschlagen. Versuche es erneut.",
    "errorInvalidToken": "Ungültiger Bestätigungslink. Registriere dich erneut.",
    "errorEmailTaken": "Diese E-Mail wird bereits verwendet. Melde dich an.",
    "signInInstead": "Stattdessen bei diesem Konto anmelden",
    "errorIdentityTaken": "Diese Identität gehört bereits zu einem anderen Caliu-Konto. Melde dich dort an.",
    "parkedNotesTitle": "Notizen aus einem anderen Konto",
    "parkedNotesBody_one": "Melde dich bei {{email}} an, um dessen Notizen auf diesem Gerät zu behalten. Ein anderes Konto löscht die eine Notiz hier, auch alles seither Geschriebene.",
    "parkedNotesBody_other": "Melde dich bei {{email}} an, um dessen Notizen auf diesem Gerät zu behalten. Ein anderes Konto löscht alle {{count}} Notizen hier, auch alles seither Geschriebene.",
    "parkedNotesBodyNoEmail_one": "Melde dich bei dem Konto an, von dem du dich abgemeldet hast, um dessen Notizen auf diesem Gerät zu behalten. Ein anderes Konto löscht die eine Notiz hier, auch alles seither Geschriebene.",
    "parkedNotesBodyNoEmail_other": "Melde dich bei dem Konto an, von dem du dich abgemeldet hast, um dessen Notizen auf diesem Gerät zu behalten. Ein anderes Konto löscht alle {{count}} Notizen hier, auch alles seither Geschriebene.",
    "parkedNotesContinue": "Weiter"
  },
  "connectors": {
    "wantsAccess": "möchte auf Caliu zugreifen",
    "couldntLoad": "Anfrage konnte nicht geladen werden",
    "authorize": "Autorisieren",
    "keepHappeningHint": "Wenn das weiterhin passiert, entferne den Connector aus deinem MCP-Client und füge ihn erneut hinzu.",
    "backToCaliu": "Zurück zu Caliu",
    "askingPermissionPrefix": "bittet um die Erlaubnis, deine Notizen und Tags über den MCP-Server von Caliu zu lesen und zu ändern.",
    "signedInAs": "Angemeldet als {{name}}.",
    "permissions": "Berechtigungen",
    "deny": "Ablehnen",
    "allow": "Erlauben"
  },
  "editorTypography": {
    "fontSize": "Schriftgröße",
    "lineHeight": "Zeilenhöhe",
    "paragraphSpacing": "Absatzabstand"
  },
  "emptyState": {
    "cmdGlyph": "⌘",
    "ctrlGlyph": "Strg",
    "shiftGlyph": "Umschalt"
  },
  "floatingMenu": {
    "undo": "Rückgängig",
    "redo": "Wiederholen",
    "taskList": "Aufgabenliste",
    "bulletList": "Aufzählungsliste",
    "orderedList": "Nummerierte Liste",
    "blockQuote": "Blockzitat",
    "separator": "Trennlinie",
    "insertTag": "Tag einfügen",
    "highlight": "Hervorheben",
    "math": "Formel",
    "removeHighlight": "Hervorhebung entfernen",
    "inlineCode": "Inline-Code",
    "codeBlock": "Codeblock",
    "insertTable": "Tabelle einfügen",
    "insertImage": "Bild einfügen",
    "hideStyleBar": "Stilleiste ausblenden",
    "attachFile": "Datei anhängen",
    "photoLibrary": "Fotos",
    "camera": "Kamera",
    "fromFile": "Aus Datei"
  },
  "imageDialog": {
    "title": "Bild einfügen",
    "tabUpload": "Datei",
    "tabUrl": "URL",
    "urlLabel": "Bild-URL",
    "urlPlaceholder": "https://beispiel.de/bild.jpg",
    "altLabel": "Alternativtext",
    "altPlaceholder": "Bild beschreiben…",
    "previewAlt": "Vorschau",
    "changeImage": "Bild ändern",
    "dropToInsert": "Zum Einfügen ablegen",
    "dropOrClick": "Bild ablegen oder zum Durchsuchen klicken",
    "formats": "PNG, JPG, GIF, WebP",
    "insert": "Bild einfügen"
  },
  "linkDialog": {
    "editTitle": "Link bearbeiten",
    "insertTitle": "Link einfügen",
    "textLabel": "Text",
    "textPlaceholder": "Linktext",
    "urlPlaceholder": "https://beispiel.de",
    "removeLink": "Link entfernen",
    "openLink": "Link öffnen",
    "editLink": "Link bearbeiten"
  },
  "noteEditor": {
    "notFound": "Notiz nicht gefunden.",
    "inTrashBanner": "Diese Notiz ist im Papierkorb. Stelle sie wieder her, um sie zu bearbeiten.",
    "restore": "Wiederherstellen",
    "noContent": "Diese Notiz hat keinen Inhalt."
  },
  "noteHeader": {
    "noteInfo": "Notiz-Info"
  },
  "table": {
    "deleteRow": "Zeile löschen",
    "deleteTable": "Tabelle löschen",
    "addRow": "Zeile hinzufügen",
    "addRowAbove": "Zeile oberhalb hinzufügen",
    "addColumn": "Spalte hinzufügen",
    "addColumnBefore": "Spalte davor hinzufügen",
    "moveRowUp": "Zeile nach oben verschieben",
    "moveRowDown": "Zeile nach unten verschieben",
    "moveColumnLeft": "Spalte nach links verschieben",
    "moveColumnRight": "Spalte nach rechts verschieben",
    "deleteColumn": "Spalte löschen",
    "actions": "Tabellenaktionen"
  },
  "syncIndicator": {
    "synced": "Synchronisiert",
    "pending_one": "{{count}} ausstehende Synchronisierung",
    "pending_other": "{{count}} ausstehende Synchronisierungen",
    "offline": "Offline",
    "offlinePending_one": "Offline · {{count}} ausstehend",
    "offlinePending_other": "Offline · {{count}} ausstehend",
    "syncing": "Synchronisieren...",
    "conflict_one": "{{count}} Konflikt",
    "conflict_other": "{{count}} Konflikte",
    "error": "Synchronisierungsfehler",
    "syncedTooltip": "Alle Änderungen gespeichert",
    "pendingTooltip_one": "{{count}} Änderung wartet auf Synchronisierung",
    "pendingTooltip_other": "{{count}} Änderungen warten auf Synchronisierung",
    "offlineTooltip": "Offline: Änderungen werden bei erneuter Verbindung synchronisiert",
    "offlinePendingTooltip_one": "Offline: {{count}} Änderung wird bei erneuter Verbindung synchronisiert",
    "offlinePendingTooltip_other": "Offline: {{count}} Änderungen werden bei erneuter Verbindung synchronisiert",
    "syncingTooltip": "Synchronisieren...",
    "syncingPendingTooltip_one": "{{count}} ausstehende Änderung wird synchronisiert...",
    "syncingPendingTooltip_other": "{{count}} ausstehende Änderungen werden synchronisiert...",
    "conflictTooltip_one": "{{count}} Notiz hat widersprüchliche Änderungen. Zum Lösen klicken.",
    "conflictTooltip_other": "{{count}} Notizen haben widersprüchliche Änderungen. Zum Lösen klicken.",
    "errorTooltip": "Synchronisierung fehlgeschlagen. Es wird automatisch erneut versucht.",
    "conflictsTitle": "Konflikte lösen",
    "local": "Auf diesem Gerät",
    "localTooltip": "Nur auf diesem Gerät. Melde dich an, um zu synchronisieren."
  },
  "image": {
    "download": "Bild herunterladen",
    "replace": "Bild ersetzen",
    "remove": "Bild entfernen"
  },
  "sharePage": {
    "goToCaliu": "Zu Caliu",
    "noteNotFoundTitle": "Notiz nicht gefunden",
    "somethingWentWrong": "Etwas ist schiefgelaufen",
    "lastUpdated": "Zuletzt aktualisiert: {{date}}",
    "tagline": "Eine Notiz-App für Denker",
    "subtagline": "Schreibe in Markdown. Synchronisiere überall. Denke klar.",
    "startWriting": "Loslegen",
    "signIn": "Anmelden",
    "openInCaliu": "In Caliu öffnen",
    "adding": "Wird hinzugefügt…",
    "addToSharedList": "Zu meiner geteilten Liste hinzufügen",
    "notFoundSubtitle": "Dieser Freigabelink ist möglicherweise abgelaufen oder wurde widerrufen.",
    "errorSubtitle": "Diese Notiz konnte nicht geladen werden. Bitte versuche es erneut."
  },
  "sharedView": {
    "loading": "Geteilte Notiz wird geladen…",
    "sharedWithYou": "Mit dir geteilt",
    "viewRaw": "Rohes Markdown anzeigen",
    "viewRendered": "Formatierte Notiz anzeigen",
    "copyMarkdown": "Markdown kopieren",
    "markdownCopied": "Markdown kopiert",
    "copyFailed": "Kopieren fehlgeschlagen",
    "notLoadedYet": "Diese Notiz ist noch nicht geladen",
    "linkCopied": "Link kopiert",
    "actions": "Notizaktionen"
  },
  "sharedWithMe": {
    "title": "Mit mir geteilt",
    "removeFromList": "Aus Liste entfernen",
    "empty": "Noch keine geteilten Notizen",
    "emptyHint": "Öffne einen Caliu-Freigabelink von einem Freund, um ihn hier hinzuzufügen. Geteilte Notizen werden auf all deinen Geräten synchronisiert."
  },
  "trashView": {
    "empty": "Der Papierkorb ist leer",
    "emptyHint": "Gelöschte Notizen erscheinen hier",
    "retention": "Notizen im Papierkorb werden nach 30 Tagen endgültig gelöscht",
    "trash": "Papierkorb"
  },
  "fileAttachment": {
    "download": "Datei herunterladen",
    "remove": "Datei entfernen"
  },
  "archiveView": {
    "archive": "Archiviert",
    "empty": "Das Archiv ist leer",
    "emptyHint": "Archivierte Notizen erscheinen hier",
    "archivedOn": "Archiviert am {{date}}"
  },
  "pro": {
    "subtitle": "Caliu, ohne Grenzen.",
    "features": [
      "Unbegrenzte Notizen",
      "Versionsverlauf für Notizen",
      "Export als PDF, HTML, RTF, ePub und im Stapel",
      "Alle Themes, Schriften und App-Symbole",
      "Unterstützt die Entwicklung von Caliu"
    ],
    "perMonth": "{{price}} pro Monat",
    "perWeek": "{{price}} pro Woche",
    "oneTime": "{{price}} einmalig",
    "perYear": "{{price}} pro Jahr",
    "or": "oder",
    "signInToSubscribe": "Anmelden, um zu abonnieren",
    "accountRequired": "Caliu Pro ist mit deinem Konto verknüpft und wird deshalb auf allen Geräten freigeschaltet.",
    "plansUnavailable": "Die Tarife konnten nicht geladen werden. Prüfe deine Verbindung und versuch es noch mal.",
    "yearly": "Jährlich",
    "monthly": "Monatlich",
    "continue": "Weiter",
    "bestValue": "Bester Wert",
    "autoRenew": "{{amount}}. Verlängert sich automatisch bis zur Kündigung. Jederzeit kündbar.",
    "freeTrial": "{{count}} Tage gratis",
    "billedSubtitle": "{{count}} Tage gratis, danach {{amount}}. Jederzeit kündbar.",
    "startTrial": "Kostenlos testen",
    "upgradeSubtitle": "Versionsverlauf, alle Themes und Schriften, Export und mehr.",
    "upgradeNow": "Jetzt upgraden",
    "thanks": "Danke, dass du Caliu unterstützt!",
    "renewsOn": "Verlängert sich am {{date}}",
    "endsOn": "Endet am {{date}}",
    "lifetime": "Lebenslanger Zugang",
    "lifetimePlan": "Lebenslang",
    "oneTimeNoRenewal": "Einmalige Zahlung",
    "launchPrice": "Einführungspreis. Später steigt er auf {{price}}.",
    "buy": "Kaufen",
    "oneTimeDisclosure": "{{amount}}. Einmalige Zahlung, keine Verlängerung.",
    "thanksMessage": "Deine Unterstützung hält Caliu unabhängig und privat.",
    "manageSubscription": "Abo verwalten",
    "contactUs": "Fragen? Schreib uns",
    "grandfatheredNote": "Als früher Unterstützer gehört dir Caliu Pro für immer. Nichts zu verlängern.",
    "webFootnote": "PDF-Export ist im Web noch nicht verfügbar.",
    "active": "Aktiv"
  },
  "find": {
    "placeholder": "In Notiz suchen",
    "matchCount": "{{current}}/{{total}}",
    "noResults": "Keine Treffer",
    "next": "Nächster Treffer",
    "previous": "Vorheriger Treffer",
    "close": "Schließen"
  },
  "conflicts": {
    "description": "Diese Notiz wurde auf einem anderen Gerät bearbeitet. Behalte eine Version.",
    "yours": "Deine Version",
    "theirs": "Ihre Version",
    "step": "{{current}} von {{total}}",
    "keepYours": "Deine behalten",
    "keepTheirs": "Ihre behalten",
    "serverError": "Die andere Version konnte nicht geladen werden.",
    "done": "Alle Konflikte gelöst.",
    "previous": "Vorheriger Konflikt",
    "next": "Nächster Konflikt",
    "copyOf": "Kopie von {{title}}"
  },
  "onboarding": {
    "welcomeTitle": "Willkommen bei Caliu",
    "welcomeSubtitle": "Ein ruhiger Ort, an dem deine Gedanken leben und atmen können.",
    "getStarted": "Loslegen",
    "magicTitle": "Sieh zu, wie deine Worte Gestalt annehmen",
    "magicSubtitle": "Du schreibst einfachen Text. Caliu macht daraus Struktur: Aufgaben, Hervorhebungen und Schlagworte, die sich von selbst einsortieren.",
    "magicLearnMore": "Lerne die Markdown-Grundlagen",
    "replay": "Wiederholen",
    "demoTitle": "Sommer am Meer",
    "demoBody": "Eine **ruhige Woche** in einer Kleinstadt planen.",
    "demoTask": "Das kleine Haus buchen",
    "demoHighlight": "==Vor== dem Frühstück schwimmen",
    "demoTags": "#sommer #pläne",
    "intentTitle": "Was bringst du hierher mit?",
    "intentSubtitle": "Wähl ein paar aus. Deine erste Notiz und deine Schlagworte warten dann schon auf dich.",
    "themeTitle": "Wähl dein Licht",
    "themeSubtitle": "Themes, die zur Stimmung deines Schreibens passen.",
    "proTitle": "Beginne mit allem",
    "proSubtitle": "Starte mit allem vom ersten Tag an. Probiere es kostenlos und behalte es nur, wenn es sich seinen Platz verdient.",
    "proTrust": "Keine Werbung. Keine Tricks. Jederzeit kündbar.",
    "tryProFree": "Pro kostenlos testen",
    "continueFree": "Mit dem kostenlosen Plan fortfahren",
    "allSetTitle": "Alles bereit",
    "allSetSubtitle": "Willkommen bei Caliu. Mach's zu deinem.",
    "startWriting": "Mit dem Schreiben beginnen",
    "firstNoteTitle": "Wo alles beginnt",
    "firstNoteBody": "Das ist meine erste Notiz. Sie lebt auf diesem Gerät, funktioniert offline und begleitet mich überall hin.",
    "firstNoteTask": "Einen Gedanken festhalten, den du bewahren möchtest",
    "next": "Weiter",
    "skip": "Überspringen",
    "back": "Zurück",
    "intents": {
      "journal": "Tagebuch",
      "ideas": "Ideen",
      "work": "Arbeit",
      "study": "Studium",
      "reading": "Lesen",
      "plans": "Pläne"
    },
    "signInCta": "Anmelden oder registrieren",
    "continueWithoutAccount": "Ohne Konto fortfahren",
    "backupTitle": "Wo deine Notizen liegen",
    "backupSubtitle": "Sie beginnen auf diesem Gerät. Mit einem Konto werden sie synchronisiert, und eine sichere Kopie erreicht all deine Geräte.",
    "syncOffTitle": "Die Synchronisierung ist aus",
    "syncOffBody": "Melde dich an, um deine Notizen auf allen Geräten zu synchronisieren.",
    "backupSignedIn": "Deine Notizen werden beim Schreiben sicher synchronisiert.",
    "backupStageDevice": "Dieses Gerät",
    "backupStageSafe": "Synchronisiert",
    "backupStageEverywhere": "Alle deine Geräte",
    "freeNotes": "{{limit}} kostenlose Notizen, ohne Konto, für immer. Pro macht sie unbegrenzt."
  },
  "backup": {
    "evictionNotice": "Notizen leben vorerst nur in diesem Browser. Browser können Website-Daten löschen, wenn der Speicher knapp wird.",
    "dismiss": "Schließen",
    "signIn": "Anmelden"
  },
  "gate": {
    "share": "Melde dich an, um Notizen zu teilen.",
    "history": "Melde dich an, um den Versionsverlauf zu behalten.",
    "import": "Melde dich an, um Notizen zu importieren."
  },
  "math": {
    "placeholder": "LaTeX",
    "sourceLabel": "LaTeX-Quelltext"
  },
  "noteLimit": {
    "banner": "{{count}} von {{limit}} Notizen",
    "paywallTitle": "Du hast die {{limit}} kostenlosen Notizen erreicht",
    "paywallBody": "Bearbeiten, Suche und Sync funktionieren weiter. Verschiebe eine Notiz in den Papierkorb, um einen Platz freizugeben, oder schreibe unbegrenzt mit Caliu Pro: monatlich, jährlich oder mit einem einmaligen Lifetime-Kauf.",
    "importCapped": "Nur {{count}} von {{total}} Dateien wurden importiert: Der kostenlose Plan erlaubt {{limit}} Notizen."
  },
  "appUpdate": {
    "available": "Eine neue Version von Caliu ist verfügbar."
  },
  "settings": {
    "title": "Einstellungen",
    "account": "Konto",
    "writing": "Schreiben",
    "keyboardShortcuts": "Tastaturkurzbefehle",
    "editor": "Editor",
    "yourNotes": "Deine Notizen",
    "about": "Über",
    "noAccount": "Kein Konto",
    "sendFeedback": "Feedback senden",
    "signInOrCreate": "Anmelden oder registrieren",
    "notesComeWithYou": "Die Notizen auf diesem Gerät kommen mit.",
    "notSyncing": "Nicht synchronisiert",
    "signInToSync": "Melde dich an, um deine Notizen zu synchronisieren.",
    "sync": "Synchronisierung",
    "security": "Sicherheit",
    "communications": "Kommunikation",
    "newsletter": "Caliu-Newsletter",
    "newsletterFooter": "Ab und zu eine kurze E-Mail über neue Versionen und das, was bei Caliu als Nächstes kommt.",
    "newsletterError": "Der Newsletter konnte nicht aktualisiert werden. Versuch es noch einmal.",
    "appearance": "Erscheinungsbild",
    "themes": "Designs",
    "sizing": "Größe",
    "systemDefault": "Systemstandard",
    "separateThemes": "Getrennte Themes für Hell und Dunkel",
    "maxWidth": "Maximale Breite",
    "maxWidthHint": "Zentriert den Text in einer lesbaren Spalte auf breiten Bildschirmen",
    "markdownReturn": "Zeilenschaltung im Markdown-Stil",
    "markdownReturnHint": "Die Zeilenschaltung bricht die Zeile um. Zweimal drücken für einen neuen Absatz",
    "newNoteStart": "Neue Notizen beginnen mit",
    "newNoteStartH1": "Überschrift 1",
    "newNoteStartH2": "Überschrift 2",
    "newNoteStartH3": "Überschrift 3",
    "newNoteStartH4": "Überschrift 4",
    "newNoteStartDate": "Datum",
    "newNoteStartDateIso": "Datum (ISO 8601)",
    "newNoteStartDateTime": "Datum und Uhrzeit",
    "newNoteStartDateTimeIso": "Datum und Uhrzeit (ISO 8601)",
    "newNoteStartEmpty": "Leer",
    "newNoteStartHint": "Gilt für Notizen, die du in der App erstellst.",
    "collapsibleSections": "Einklappbare Abschnitte",
    "collapsibleSectionsHint": "Ermöglicht es, eine Überschrift samt Inhalt hinter einem Pfeil einzuklappen",
    "experimental": "Experimentell",
    "general": "Allgemein"
  },
  "toolbar": {
    "toggleSidebar": "Seitenleiste ein-/ausblenden",
    "toggleInspector": "Inspektor ein-/ausblenden",
    "searchNotes": "Notizen suchen",
    "newNote": "Neue Notiz",
    "findInNote": "In Notiz suchen",
    "showToolbar": "Symbolleiste einblenden",
    "hideToolbar": "Symbolleiste ausblenden",
    "moreNoteActions": "Weitere Notizaktionen",
    "undo": "Rückgängig",
    "redo": "Wiederholen",
    "zenMode": "Zen-Modus",
    "sourceMode": "Quellmodus",
    "richEditor": "Rich-Text-Editor",
    "sortBy": "Sortieren nach",
    "bold": "Fett",
    "italic": "Kursiv",
    "heading": "Überschrift",
    "list": "Liste",
    "link": "Verknüpfung",
    "insert": "Einfügen",
    "more": "Mehr",
    "strikethrough": "Durchgestrichen",
    "table": "Tabelle",
    "horizontalRule": "Horizontale Linie",
    "codeBlock": "Codeblock",
    "inlineCode": "Inline-Code",
    "blockQuote": "Zitat",
    "math": "Formel",
    "highlight": "Hervorhebung",
    "bulletList": "Aufzählung",
    "orderedList": "Nummerierte Liste",
    "photoLibrary": "Fotomediathek",
    "camera": "Kamera",
    "files": "Dateien",
    "yellow": "Gelb",
    "green": "Grün",
    "blue": "Blau",
    "pink": "Rosa",
    "purple": "Lila",
    "heading1": "Überschrift 1",
    "heading2": "Überschrift 2",
    "heading3": "Überschrift 3",
    "heading4": "Überschrift 4",
    "heading5": "Überschrift 5",
    "heading6": "Überschrift 6",
    "removeHighlight": "Hervorhebung entfernen"
  },
  "whatsNew": {
    "title": "Neuigkeiten",
    "tagIconsTitle": "Symbole, gezeichnet für Caliu",
    "tagIconsBody": "Jedes Symbol in der App ist neu und eigens für Caliu gestaltet. Gib jedem Tag sein eigenes Symbol und such sie in deiner Sprache.",
    "newNoteStartTitle": "Notizen beginnen, wie du willst",
    "newNoteStartBody": "Eine neue Notiz kann mit einer Überschrift, dem heutigen Datum, Datum und Uhrzeit oder einer leeren Seite beginnen. Wähle es in den Einstellungen unter Editor.",
    "typographyTitle": "Schrift, ganz genau eingestellt",
    "typographyBody": "Wähle die genaue Schriftgröße, Zeilenhöhe und den Absatzabstand deiner Notizen, in den Einstellungen unter Schriftart.",
    "typographySample": "Jede Notiz folgt der Größe, Zeilenhöhe und dem Abstand, die du einstellst, auf den Punkt genau.",
    "sampleMorningPages": "Morgenseiten",
    "newsletterTitle": "Neu: der Caliu-Newsletter",
    "newsletterBody": "Ab jetzt erfährst du in einer kurzen E-Mail, was jede Version Neues bringt, in deiner Sprache. Schalte ihn ein, wenn du magst. Du kannst das jederzeit in den Einstellungen ändern."
  },
  "sharing": {
    "inviteByEmail": "Per E-Mail einladen",
    "invite": "Einladen",
    "roleOwner": "Eigentümer",
    "roleEditor": "Kann bearbeiten",
    "roleViewer": "Kann ansehen",
    "generalAccess": "Allgemeiner Zugriff",
    "shareWithLink": "Per Link teilen",
    "accessRestricted": "Nur eingeladene Personen",
    "accessView": "Alle mit dem Link können ansehen",
    "accessEdit": "Alle mit dem Link können bearbeiten",
    "remove": "Entfernen",
    "leave": "Verlassen",
    "leaveNote": "Notiz verlassen",
    "leaveConfirmTitle": "Diese Notiz verlassen?",
    "leaveConfirmBody": "Sie verschwindet auf allen deinen Geräten aus deinen Listen. Der Eigentümer kann dich erneut einladen.",
    "leaveSelectedTitle": "Geteilte Notizen verlassen?",
    "leaveSelectedBody_one": "Du verlässt {{count}} mit dir geteilte Notiz. Deine eigenen Notizen kommen in den Papierkorb.",
    "leaveSelectedBody_other": "Du verlässt {{count}} mit dir geteilte Notizen. Deine eigenen Notizen kommen in den Papierkorb.",
    "sharedBy": "Geteilt von {{name}}",
    "sharedList": "Geteilt",
    "viewOnly": "Nur ansehen",
    "accessNowEditor": "Du kannst diese Notiz jetzt bearbeiten.",
    "accessNowViewer": "Du kannst diese Notiz jetzt nur noch ansehen.",
    "accessRemoved": "Du hast keinen Zugriff mehr auf diese Notiz.",
    "unsentSavedAsCopy": "Deine nicht gesendeten Änderungen wurden als Kopie gespeichert.",
    "privateNote": "Private Notiz",
    "memberLimit": "Eine Notiz kann mit bis zu 50 Personen geteilt werden.",
    "rateLimit": "Zu viele Einladungen. Versuch es später noch einmal.",
    "inviteFailed": "Die Einladungen konnten nicht gesendet werden. Versuch es noch einmal.",
    "invalidEmail": "Gib eine gültige E-Mail-Adresse ein.",
    "onlineOnly": "Stell eine Internetverbindung her, um die Freigabe zu verwalten.",
    "you": "Du",
    "ownerOnly": "Nur der Eigentümer kann ändern, wer Zugriff hat.",
    "unavailable": "Teilen ist gerade nicht verfügbar. Versuch es später noch einmal.",
    "updateFailed": "Die Freigabe konnte nicht aktualisiert werden. Versuch es noch einmal.",
    "inviteInvalid": "Diese Einladung ist nicht mehr gültig.",
    "copyLink": "Link kopieren",
    "invited": "Eingeladen",
    "copied": "Kopiert",
    "accessRestrictedHint": "Nur Personen, die du einlädst, können sie öffnen.",
    "onlyYouHint": "Nur du kannst sie öffnen.",
    "accessViewHint": "Alle mit dem Link können sie lesen, ohne Konto.",
    "accessEditHint": "Alle mit dem Link können sie bearbeiten.",
    "roleBelowLink": "Alle mit dem Link können bearbeiten, also können auch eingeladene Personen bearbeiten.",
    "inviteAs": "Einladen als",
    "revokeInvite": "Einladung widerrufen",
    "statusPeople_one": "{{count}} Person",
    "statusPeople_other": "{{count}} Personen",
    "publicLink": "Öffentlicher Link",
    "statusFrom": "Von {{name}}",
    "removeConfirmTitle": "{{name}} entfernen?",
    "removeConfirmBody": "Diese Person hat dann keinen Zugriff mehr auf diese Notiz.",
    "revokeConfirmTitle": "Einladung an {{name}} widerrufen?",
    "revokeConfirmBody": "Der Einladungslink funktioniert dann nicht mehr.",
    "peopleWithAccess": "Personen mit Zugriff",
    "addPeoplePlaceholder": "Personen per E-Mail hinzufügen",
    "invitePro": "Personen einladen ist Teil von Caliu Pro.",
    "inviteKeepsAccess": "Eingeladene Personen behalten den Zugriff, wenn du den Link deaktivierst.",
    "youSuffix": "(du)"
  },
  "noAccess": {
    "title": "Du hast keinen Zugriff auf diese Notiz",
    "linkBody": "Der Besitzer hat sie nicht mit dir geteilt. Bitte ihn, dich einzuladen oder den Link zu aktivieren.",
    "signedOutBody": "Melde dich mit dem Konto an, mit dem sie geteilt wurde.",
    "inviteTitle": "Diese Einladung ist nicht mehr gültig",
    "inviteBody": "Bitte die Person, die dich eingeladen hat, um eine neue.",
    "removedTitle": "Du hast keinen Zugriff mehr auf diese Notiz",
    "removedBody": "Der Besitzer hat dich entfernt.",
    "removedCopyBody": "Der Besitzer hat dich entfernt. Deine nicht gesendeten Änderungen wurden als Kopie in deinen Notizen behalten.",
    "backToNotes": "Zurück zu den Notizen",
    "signIn": "Anmelden"
  }
}
